import React, { SyntheticEvent } from 'react';

export const BooleanCell = (row : any) => {
    if (row.value) {
        return <span>Igen</span>;
    }
    return <span>Nem</span>;
};

export const WeightCell = (row : any) => {
    return row.value ? `${row.value / 1000} kg` : '';
};

export const PercentCell = (row: any) => {
    return row.value ? `${row.value}%` : '';
};

export const OpenInNewCell = (getUrl: (row: any) => string) => (row: any) => {
    return <a href={getUrl(row)} target="_blank" onClick={ (e: SyntheticEvent) => { e.stopPropagation(); } }><i className="fa fa-external-link-alt" /></a>;
};



// WEBPACK FOOTER //
// ./src/components/Table/Cell.tsx